import axios from "axios";

// Validate voucher code
export const validateVoucher = async ({ code, eventId, ticketTypeId, orderAmount }) => {
  const response = await axios.post("/vouchers/validate", {
    code,
    eventId,
    ticketTypeId,
    orderAmount
  });

  return response;
};

// Admin functions (for future use)
export const getVouchers = async (params = {}) => {
  const response = await axios.get("/vouchers", { params });
  return response;
};

export const getVoucherById = async (id) => {
  const response = await axios.get(`/vouchers/${id}`);
  return response;
};

export const createVoucher = async (voucherData) => {
  const response = await axios.post("/vouchers", voucherData);
  return response;
};

export const updateVoucher = async (id, voucherData) => {
  const response = await axios.put(`/vouchers/${id}`, voucherData);
  return response;
};

export const deleteVoucher = async (id) => {
  const response = await axios.delete(`/vouchers/${id}`);
  return response;
};

export const getVoucherStats = async (id) => {
  const response = await axios.get(`/vouchers/${id}/stats`);
  return response;
};

export const getEventVoucherStats = async (eventId) => {
  const response = await axios.get(`/vouchers/event/${eventId}/stats`);
  return response;
};
